module.exports = __webpack_public_path__ + "img/icon-flag-germany.8a94bbbb.png";